import { tierIndex } from "../../../constants/ampTiers";
import {
  ZYGOSITY_TYPE_INDEX,
  ZYGOSITY_TYPE_INDEX_PHASED,
} from "../../../constants/zygosity";
import calcCodingImpact from "../../../helpers/calcCodingImpact";
import {
  pathogenicityIndex,
  impactIndex,
  impactColorIndex,
  impactLookup,
} from "../../../constants/pathogenicity";

class ClinicalSampleVariant {
  constructor(data, variant, sample, phasingGroup) {
    const zygDict = phasingGroup
      ? ZYGOSITY_TYPE_INDEX_PHASED
      : ZYGOSITY_TYPE_INDEX;

    const impact = calcCodingImpact(data.coding_impact || "non coding");
    this.id = `${variant.id}-${sample.sampleName}-${data?.table_index}`;
    this.codingImpactIndex = impactIndex[impact];
    this.codingColorIndex =
      impactColorIndex[impactLookup[this.codingImpactIndex]];
    this.pathoIndex = pathogenicityIndex[data.acmg_class];
    this.tableIndex = data?.table_index;
    this.variant = variant;
    this.analysisId = sample.sampleId;
    this.sampleName = sample?.sampleName || "-";
    this.allelicBalance = data?.allelic_balance ?? null;
    this.coverage = data?.coverage ?? null;
    this.genes = data?.genes || [];
    this.frequency = data?.frequency ?? null;
    this.sample = sample;
    this.acmgRules = data.ACMG_rules || [];
    this.ampRules = data?.AMP_rules || [];
    this.zygosity = zygDict[data.zygosity] || null;
    this.tier = tierIndex[data.tier] ?? null;
    this.cnvOverlapSampleSet = new Set();
    this.phasingGroup = phasingGroup;
  }
}

export default ClinicalSampleVariant;
